import { observer } from "mobx-react-lite";
import { VirtualizedItemList } from "@/components/item-list";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { TrashPageListEmpty } from "@/pages/trash/trash-page-list-empty";

export const TrashPageList = observer(() => {
  const page = useTabPageStore("trashPage");

  if (!page.itemRows.length) {
    return <TrashPageListEmpty />;
  }

  return (
    <>
      <VirtualizedItemList rows={page.itemRows} listState={page.listState} />
      {page.listState.multiSelectUi}
    </>
  );
});
